import { GdSmartFilterConditionOperator } from '../typings/graphql-grid';
import {
    FeedFilterCondition,
    FeedFilterOperationControlValues
} from '../typings/groupsEditState';

export const ADD_SMART_FILTER_CONDITION = 'ADD_SMART_FILTER_CONDITION';
export type ADD_SMART_FILTER_CONDITION = typeof ADD_SMART_FILTER_CONDITION;

export interface AddSmartFilterConditionAction {
    type: ADD_SMART_FILTER_CONDITION;
    condition: FeedFilterCondition;
}

export function addSmartFilterCondition(
    condition: FeedFilterCondition
): AddSmartFilterConditionAction {
    return {
        type: ADD_SMART_FILTER_CONDITION,
        condition
    };
}

export const REMOVE_SMART_FILTER_CONDITION = 'REMOVE_SMART_FILTER_CONDITION';
export type REMOVE_SMART_FILTER_CONDITION = typeof REMOVE_SMART_FILTER_CONDITION;

export interface RemoveSmartFilterConditionAction {
    type: REMOVE_SMART_FILTER_CONDITION;
    id: string;
}

export function removeSmartFilterCondition(
    id: string
): RemoveSmartFilterConditionAction {
    return {
        type: REMOVE_SMART_FILTER_CONDITION,
        id
    };
}

export const CHANGE_SMART_FILTER_CONDITION_FIELD =
    'CHANGE_SMART_FILTER_CONDITION_FIELD';
export type CHANGE_SMART_FILTER_CONDITION_FIELD = typeof CHANGE_SMART_FILTER_CONDITION_FIELD;

export interface ChangeSmartFilterConditionFieldPayload {
    id: string;
    field: string;
}

export interface ChangeSmartFilterConditionFieldAction {
    type: CHANGE_SMART_FILTER_CONDITION_FIELD;
    payload: ChangeSmartFilterConditionFieldPayload;
}

export function changeSmartFilterConditionField(
    payload: ChangeSmartFilterConditionFieldPayload
): ChangeSmartFilterConditionFieldAction {
    return {
        type: CHANGE_SMART_FILTER_CONDITION_FIELD,
        payload
    };
}

export const CHANGE_SMART_FILTER_CONDITION_OPERATOR =
    'CHANGE_SMART_FILTER_CONDITION_OPERATOR';
export type CHANGE_SMART_FILTER_CONDITION_OPERATOR = typeof CHANGE_SMART_FILTER_CONDITION_OPERATOR;

export interface ChangeSmartFilterConditionOperatorPayload {
    id: string;
    operator: GdSmartFilterConditionOperator;
    values: FeedFilterOperationControlValues;
}

export interface ChangeSmartFilterConditionOperatorAction {
    type: CHANGE_SMART_FILTER_CONDITION_OPERATOR;
    payload: ChangeSmartFilterConditionOperatorPayload;
}

export function changeSmartFilterConditionOperator(
    payload: ChangeSmartFilterConditionOperatorPayload
): ChangeSmartFilterConditionOperatorAction {
    return {
        type: CHANGE_SMART_FILTER_CONDITION_OPERATOR,
        payload
    };
}

export const CHANGE_SMART_FILTER_CONDITION_VALUES =
    'CHANGE_SMART_FILTER_CONDITION_VALUES';
export type CHANGE_SMART_FILTER_CONDITION_VALUES = typeof CHANGE_SMART_FILTER_CONDITION_VALUES;

export interface ChangeSmartFilterConditionValuesPayload {
    id: string;
    values: FeedFilterOperationControlValues;
}

export interface ChangeSmartFilterConditionValuesAction {
    type: CHANGE_SMART_FILTER_CONDITION_VALUES;
    payload: ChangeSmartFilterConditionValuesPayload;
}

export function changeSmartFilterConditionValues(
    payload: ChangeSmartFilterConditionValuesPayload
): ChangeSmartFilterConditionValuesAction {
    return {
        type: CHANGE_SMART_FILTER_CONDITION_VALUES,
        payload
    };
}

export type SmartFilterConditionsAction =
    | AddSmartFilterConditionAction
    | RemoveSmartFilterConditionAction
    | ChangeSmartFilterConditionFieldAction
    | ChangeSmartFilterConditionOperatorAction
    | ChangeSmartFilterConditionValuesAction;
